import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import './index.css';
import './i18n';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { reloadOnChunkLoadError } from './utils/chunkLoadRecovery';
import { ensureLatestDeployment } from './utils/deploymentCache';
import { installSessionHandoffListener } from './utils/tabManager';

installSessionHandoffListener();

window.addEventListener('error', reloadOnChunkLoadError);
window.addEventListener('unhandledrejection', reloadOnChunkLoadError);

const renderApp = () => {
  ReactDOM.render(<App />, document.getElementById('root'));
};

ensureLatestDeployment()
  .then(renderApp)
  .catch(renderApp);
 
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
